import React from "react";
import { Trans } from "react-i18next";
import { Button } from "@unleashed/components/ui/Button";
import { Heading } from "../../ui/components/Heading";

type UploadModalProps = {
  showModal: boolean;
  handleShowModal: (bool: boolean) => void;
  modalHeader: string;
  message: string;
  onSubmit: () => void;
};

const WingmanAdminConfirmReplaceModal = ({ showModal, handleShowModal, modalHeader, message, onSubmit }: UploadModalProps) => {
  const handleSubmit = () => {
    onSubmit();
    handleShowModal(false);
  };

  return showModal ? (
    <div className="fixed top-0 left-0 bottom-0 right-0 h-screen w-screen flex items-center justify-center backdrop-blur-sm bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg shadow-lg w-96">
        <div className="border-b-2 border-unleashed-pink py-4 px-6">
          <Heading className="text-4xl" size="lg">{modalHeader}</Heading>
        </div>
        <div className="flex flex-col p-6">
          <p className="text-gray-700 text-base mb-4">{message}</p>
          <div className="flex justify-end gap-2 pt-4">
            <Button
              type="button"
              className="inline-flex items-center text-unleashed-pink bg-white hover:bg-primary hover:text-white transition"
              onClick={() => handleShowModal(false)}
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              type="button"
              className="inline-flex items-center"
              onClick={handleSubmit}
            >
              <Trans>Continue</Trans>
            </Button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default WingmanAdminConfirmReplaceModal;
